import { render, staticRenderFns } from "./AssignmentButtonRibbon.vue?vue&type=template&id=cad21f24&"
import script from "./AssignmentButtonRibbon.vue?vue&type=script&lang=js&"
export * from "./AssignmentButtonRibbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports